import React from 'react';
import { isEmpty } from 'lodash';
import { Grid } from 'semantic-ui-react';
import { PositionTile } from '../components/tile/positionTile';

const PositionCards = ({ publicPostings }) => {
  if (isEmpty(publicPostings)) {
    return (
      <div>No postings available</div>
    );
  }

  return (
    <Grid
      stretched textAlign='center' centered
      stackable padded={false}
    >
      {publicPostings.map(post => (
        <Grid.Column
          stretched textAlign='center'
          widescreen={5} largeScreen={5} computer={5}
          mobile={16} tablet={8} key={`post-${post.postingSlug}`}
        >
          <PositionTile post={post} />
        </Grid.Column>
      ))}
    </Grid>
  );
};

export default PositionCards;



// WEBPACK FOOTER //
// ./src/components/events/components/positionCards.js